// extracted by mini-css-extract-plugin
module.exports = {"techItem":"Tech_techItem__-r4GH"};